import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue";
import _imports_0 from '@/assets/swell-icon.svg';
import _imports_1 from '@/assets/pulse-icon.svg';
import _imports_2 from '@/assets/logo.svg';
const _hoisted_1 = {
  class: "min-h-screen flex flex-column"
};
const _hoisted_2 = {
  key: 0,
  class: "bg-indigo-500 py-3 px-5 flex align-items-center justify-content-between relative lg:static",
  style: {
    "min-height": "80px",
    "z-index": "10"
  }
};
const _hoisted_3 = {
  class: "cursor-pointer block lg:hidden text-indigo-50 p-ripple"
};
const _hoisted_4 = {
  class: "align-items-center flex-grow-1 justify-content-between hidden lg:flex absolute lg:static w-full bg-indigo-500 left-0 top-100 shadow-2 lg:shadow-none"
};
const _hoisted_5 = {
  class: "list-none p-0 m-0 flex lg:align-items-center select-none flex-column lg:flex-row"
};
const _hoisted_6 = {
  key: 0
};
const _hoisted_7 = {
  key: 1
};
const _hoisted_8 = {
  class: "list-none py-3 px-6 m-0 lg:px-0 lg:py-0 border-round shadow-0 lg:border-1 border-50 lg:shadow-2 lg:absolute surface-overlay hidden origin-top w-full lg:w-15rem cursor-pointer z-5"
};
const _hoisted_9 = {
  key: 0
};
const _hoisted_10 = {
  key: 1
};
const _hoisted_11 = {
  key: 2
};
const _hoisted_12 = {
  key: 3
};
const _hoisted_13 = {
  key: 4
};
const _hoisted_14 = {
  key: 5
};
const _hoisted_15 = {
  key: 6
};
const _hoisted_16 = {
  key: 7
};
const _hoisted_17 = {
  key: 8
};
const _hoisted_18 = {
  key: 9
};
const _hoisted_19 = {
  key: 10
};
const _hoisted_20 = {
  key: 11
};
const _hoisted_21 = {
  key: 12,
  class: "border-top-1 border-100 mt-1 pt-1"
};
const _hoisted_22 = {
  class: "flex gap-1 px-2 py-1"
};
const _hoisted_23 = {
  href: "/swell",
  target: "_blank",
  rel: "noopener",
  class: "flex flex-column align-items-center gap-1 px-2 py-2 flex-1 no-underline border-round cursor-pointer hover:surface-100 transition-colors transition-duration-150 p-ripple"
};
const _hoisted_24 = {
  href: "/pulse",
  target: "_blank",
  rel: "noopener",
  class: "flex flex-column align-items-center gap-1 px-2 py-2 flex-1 no-underline border-round cursor-pointer hover:surface-100 transition-colors transition-duration-150 p-ripple"
};
const _hoisted_25 = {
  class: "list-none p-0 m-0 flex lg:align-items-center select-none flex-column lg:flex-row border-top-1 border-indigo-400 lg:border-top-none"
};
const _hoisted_26 = {
  key: 0,
  class: "border-bottom-1 border-indigo-400 lg:border-bottom-none flex lg:align-items-center px-6 py-3 lg:px-0 lg:py-0 lg:mx-2"
};
const _hoisted_27 = {
  key: 1,
  class: "border-bottom-1 border-indigo-400 lg:border-bottom-none"
};
const _hoisted_28 = {
  class: "flex px-6 p-3 lg:px-6 lg:py-2 align-items-center justify-content-between font-medium"
};
const _hoisted_29 = {
  key: 2
};
const _hoisted_30 = {
  key: 0,
  class: "update-banner flex align-items-center gap-3 px-4 py-3 bg-white border-2 border-gray-200 text-900 border-round-2xl"
};
const _hoisted_31 = {
  key: 1,
  class: "flex flex-column sm:flex-row justify-content-between gap-2 align-items-center p-5 px-6 border-top-1 border-gray-100 surface-overlay"
};
const _hoisted_32 = {
  class: "flex sm:flex-row flex-column align-items-center gap-2"
};
const _hoisted_33 = {
  class: "text-xs"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_HeaderBrand = _resolveComponent("HeaderBrand");
  const _component_router_link = _resolveComponent("router-link");
  const _component_ToggleSwitch = _resolveComponent("ToggleSwitch");
  const _component_HeaderNotifications = _resolveComponent("HeaderNotifications");
  const _component_HeaderUser = _resolveComponent("HeaderUser");
  const _component_router_view = _resolveComponent("router-view");
  const _component_Button = _resolveComponent("Button");
  const _component_ClientProtocolsViewDialog = _resolveComponent("ClientProtocolsViewDialog");
  const _component_Toast = _resolveComponent("Toast");
  const _directive_ripple = _resolveDirective("ripple");
  const _directive_styleclass = _resolveDirective("styleclass");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [$setup.headerVisible && $setup.store.currentUser ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_HeaderBrand), _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_3, [...(_cache[2] || (_cache[2] = [_createElementVNode("i", {
    class: "pi pi-bars text-4xl"
  }, null, -1)]))])), [[_directive_ripple], [_directive_styleclass, {
    selector: '@next',
    enterFromClass: 'hidden',
    leaveToClass: 'hidden',
    hideOnOutsideClick: true
  }]]), _createElementVNode("div", _hoisted_4, [_createElementVNode("ul", _hoisted_5, [$setup.store.currentUser.user_type != 'staff' || $setup.store.currentUser.user_type == 'staff' && $setup.store.currentUser.staff.permission_campaigns != 'no-access' ? (_openBlock(), _createElementBlock("li", _hoisted_6, [_withDirectives((_openBlock(), _createBlock(_component_router_link, {
    to: "/campaign",
    class: _normalizeClass(["flex px-6 p-3 lg:px-3 lg:py-2 align-items-center no-underline font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple", {
      'text-indigo-50 font-bold': $setup.route.matched[0].name == 'campaign',
      'text-indigo-100': $setup.route.matched[0].name != 'campaign'
    }])
  }, {
    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createElementVNode("i", {
      class: "pi pi-megaphone mr-2"
    }, null, -1), _createElementVNode("span", null, "Campaigns", -1)]))]),
    _: 1
  }, 8, ["class"])), [[_directive_ripple]])])) : _createCommentVNode("", true), $setup.store.currentUser.user_type == 'staff' && !$setup.store.clientView ? (_openBlock(), _createElementBlock("li", _hoisted_7, [_withDirectives((_openBlock(), _createElementBlock("a", {
    class: _normalizeClass(["flex px-6 p-3 lg:px-3 lg:py-2 align-items-center font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple", {
      'text-indigo-50 font-bold': $setup.route.matched[0].name == 'management',
      'text-indigo-100': $setup.route.matched[0].name != 'management'
    }])
  }, [...(_cache[4] || (_cache[4] = [_createElementVNode("i", {
    class: "pi pi-cog mr-2"
  }, null, -1), _createElementVNode("span", null, "Management", -1), _createElementVNode("i", {
    class: "pi pi-angle-down ml-auto lg:ml-2"
  }, null, -1)]))], 2)), [[_directive_ripple], [_directive_styleclass, {
    selector: '@next',
    enterFromClass: 'hidden',
    enterActiveClass: 'scalein',
    leaveToClass: 'hidden',
    leaveActiveClass: 'fadeout',
    hideOnOutsideClick: true
  }]]), _createElementVNode("ul", _hoisted_8, [$setup.store.currentUser.user_type == 'staff' && $setup.store.currentUser.staff.permission_influencers != 'no-access' ? (_openBlock(), _createElementBlock("li", _hoisted_9, [_withDirectives((_openBlock(), _createBlock(_component_router_link, {
    to: "/management/influencer",
    class: "flex p-3 align-items-center text-600 no-underline hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple"
  }, {
    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createElementVNode("i", {
      class: "pi pi-users mr-2"
    }, null, -1), _createElementVNode("span", {
      class: "font-medium"
    }, "Influencers", -1)]))]),
    _: 1
  })), [[_directive_ripple]])])) : _createCommentVNode("", true), $setup.store.currentUser.user_type == 'staff' && $setup.store.currentUser.staff.permission_influencers != 'no-access' ? (_openBlock(), _createElementBlock("li", _hoisted_10, [_withDirectives((_openBlock(), _createBlock(_component_router_link, {
    to: "/management/influencer-discovery",
    class: "flex p-3 align-items-center text-600 no-underline hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple"
  }, {
    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createElementVNode("i", {
      class: "pi pi-users mr-2"
    }, null, -1), _createElementVNode("span", {
      class: "font-medium"
    }, "Influencer Discovery", -1)]))]),
    _: 1
  })), [[_directive_ripple]])])) : _createCommentVNode("", true), $setup.store.currentUser.user_type == 'staff' && $setup.store.currentUser.staff.permission_influencers != 'no-access' ? (_openBlock(), _createElementBlock("li", _hoisted_11, [_withDirectives((_openBlock(), _createBlock(_component_router_link, {
    to: "/management/influencer-agency",
    class: "flex p-3 align-items-center text-600 no-underline hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple"
  }, {
    default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createElementVNode("i", {
      class: "pi pi-users mr-2"
    }, null, -1), _createElementVNode("span", {
      class: "font-medium"
    }, "Influencer Agency", -1)]))]),
    _: 1
  })), [[_directive_ripple]])])) : _createCommentVNode("", true), $setup.store.currentUser.user_type == 'staff' && $setup.store.currentUser.staff.permission_brands != 'no-access' ? (_openBlock(), _createElementBlock("li", _hoisted_12, [_withDirectives((_openBlock(), _createBlock(_component_router_link, {
    to: "/management/brand",
    class: "flex p-3 align-items-center text-600 no-underline hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple"
  }, {
    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createElementVNode("i", {
      class: "pi pi-briefcase mr-2"
    }, null, -1), _createElementVNode("span", {
      class: "font-medium"
    }, "Brands", -1)]))]),
    _: 1
  })), [[_directive_ripple]])])) : _createCommentVNode("", true), $setup.store.currentUser.user_type == 'staff' && $setup.store.currentUser.staff.permission_clients != 'no-access' ? (_openBlock(), _createElementBlock("li", _hoisted_13, [_withDirectives((_openBlock(), _createBlock(_component_router_link, {
    to: "/management/client",
    class: "flex p-3 align-items-center text-600 no-underline hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple"
  }, {
    default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createElementVNode("i", {
      class: "pi pi-user mr-2"
    }, null, -1), _createElementVNode("span", {
      class: "font-medium"
    }, "Clients", -1)]))]),
    _: 1
  })), [[_directive_ripple]])])) : _createCommentVNode("", true), $setup.store.currentUser.user_type == 'staff' && $setup.store.currentUser.staff.permission_campaigns != 'no-access' ? (_openBlock(), _createElementBlock("li", _hoisted_14, [_withDirectives((_openBlock(), _createBlock(_component_router_link, {
    to: "/management/management-campaign",
    class: "flex p-3 align-items-center text-600 no-underline hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple"
  }, {
    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createElementVNode("i", {
      class: "pi pi-megaphone mr-2"
    }, null, -1), _createElementVNode("span", {
      class: "font-medium"
    }, "Campaign", -1)]))]),
    _: 1
  })), [[_directive_ripple]])])) : _createCommentVNode("", true), $setup.store.currentUser.user_type == 'staff' && $setup.store.currentUser.staff.permission_campaigns != 'no-access' ? (_openBlock(), _createElementBlock("li", _hoisted_15, [_withDirectives((_openBlock(), _createBlock(_component_router_link, {
    to: "/management/tracker",
    class: "flex p-3 align-items-center text-600 no-underline hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple"
  }, {
    default: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createElementVNode("i", {
      class: "pi pi-bolt mr-2"
    }, null, -1), _createElementVNode("span", {
      class: "font-medium"
    }, "Impactful", -1)]))]),
    _: 1
  })), [[_directive_ripple]])])) : _createCommentVNode("", true), $setup.store.currentUser.user_type == 'staff' && $setup.performanceUserIds.includes($setup.store.currentUser.id) ? (_openBlock(), _createElementBlock("li", _hoisted_16, [_withDirectives((_openBlock(), _createBlock(_component_router_link, {
    to: "/management/performance",
    class: "flex p-3 align-items-center text-600 no-underline hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple"
  }, {
    default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createElementVNode("i", {
      class: "pi pi-chart-bar mr-2"
    }, null, -1), _createElementVNode("span", {
      class: "font-medium"
    }, "Performance", -1)]))]),
    _: 1
  })), [[_directive_ripple]])])) : _createCommentVNode("", true), $setup.store.currentUser.user_type == 'staff' && $setup.smAccess.member ? (_openBlock(), _createElementBlock("li", _hoisted_17, [_withDirectives((_openBlock(), _createBlock(_component_router_link, {
    to: "/management/stars-magnet",
    class: "flex p-3 align-items-center text-600 no-underline hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple"
  }, {
    default: _withCtx(() => [...(_cache[13] || (_cache[13] = [_createElementVNode("i", {
      class: "pi pi-star mr-2"
    }, null, -1), _createElementVNode("span", {
      class: "font-medium"
    }, "Stars Magnet", -1)]))]),
    _: 1
  })), [[_directive_ripple]])])) : _createCommentVNode("", true), $setup.store.currentUser.user_type == 'staff' && $setup.store.currentUser.staff.permission_finance != 'no-access' ? (_openBlock(), _createElementBlock("li", _hoisted_18, [_withDirectives((_openBlock(), _createBlock(_component_router_link, {
    to: "/management/finance",
    class: "flex p-3 align-items-center text-600 no-underline hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple"
  }, {
    default: _withCtx(() => [...(_cache[14] || (_cache[14] = [_createElementVNode("i", {
      class: "pi pi-dollar mr-2"
    }, null, -1), _createElementVNode("span", {
      class: "font-medium"
    }, "Finance", -1)]))]),
    _: 1
  })), [[_directive_ripple]])])) : _createCommentVNode("", true), $setup.store.currentUser.user_type == 'staff' && $setup.store.currentUser.staff.permission_blog != 'no-access' ? (_openBlock(), _createElementBlock("li", _hoisted_19, [_withDirectives((_openBlock(), _createBlock(_component_router_link, {
    to: "/management/blog",
    class: "flex p-3 align-items-center text-600 no-underline hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple"
  }, {
    default: _withCtx(() => [...(_cache[15] || (_cache[15] = [_createElementVNode("i", {
      class: "pi pi-pencil mr-2"
    }, null, -1), _createElementVNode("span", {
      class: "font-medium"
    }, "Blog", -1)]))]),
    _: 1
  })), [[_directive_ripple]])])) : _createCommentVNode("", true), $setup.store.currentUser.user_type == 'staff' && $setup.store.currentUser.staff.permission_staff != 'no-access' ? (_openBlock(), _createElementBlock("li", _hoisted_20, [_withDirectives((_openBlock(), _createBlock(_component_router_link, {
    to: "/management/staff",
    class: "flex p-3 align-items-center text-600 no-underline hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple"
  }, {
    default: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createElementVNode("i", {
      class: "pi pi-id-card mr-2"
    }, null, -1), _createElementVNode("span", {
      class: "font-medium"
    }, "Staff", -1)]))]),
    _: 1
  })), [[_directive_ripple]])])) : _createCommentVNode("", true), $setup.store.currentUser.user_type == 'staff' ? (_openBlock(), _createElementBlock("li", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_withDirectives((_openBlock(), _createElementBlock("a", _hoisted_23, [...(_cache[17] || (_cache[17] = [_createElementVNode("img", {
    src: _imports_0,
    alt: "Swell",
    style: {
      "width": "3.25rem",
      "height": "3.25rem",
      "border-radius": "12px"
    }
  }, null, -1), _createElementVNode("span", {
    class: "font-bold text-700 text-sm"
  }, "Swell", -1)]))])), [[_directive_ripple]]), _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_24, [...(_cache[18] || (_cache[18] = [_createElementVNode("img", {
    src: _imports_1,
    alt: "Pulse",
    style: {
      "width": "3.25rem",
      "height": "3.25rem",
      "border-radius": "12px"
    }
  }, null, -1), _createElementVNode("span", {
    class: "font-bold text-700 text-sm"
  }, "Pulse", -1), _createElementVNode("span", {
    class: "text-400",
    style: {
      "font-size": "0.65rem"
    }
  }, "Coming soon", -1)]))])), [[_directive_ripple]])])])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)]), _createElementVNode("ul", _hoisted_25, [$setup.store.currentUser.user_type == 'staff' && !$setup.store.clientView && $setup.store.currentBrand?.id ? (_openBlock(), _createElementBlock("li", _hoisted_26, [_withDirectives((_openBlock(), _createElementBlock("a", {
    onClick: _cache[0] || (_cache[0] = $event => $options.openClientProtocols()),
    class: "protocols-pill flex align-items-center gap-2 text-white no-underline font-medium cursor-pointer p-ripple"
  }, [...(_cache[19] || (_cache[19] = [_createElementVNode("i", {
    class: "pi pi-book text-base"
  }, null, -1), _createElementVNode("span", {
    class: "font-medium text-sm"
  }, "Client Protocols", -1)]))])), [[_directive_ripple]])])) : _createCommentVNode("", true), $setup.store.currentUser.user_type == 'staff' && (this.route.matched[0].name == 'campaign' || this.route.matched[0].name == 'discovery') ? (_openBlock(), _createElementBlock("li", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_cache[20] || (_cache[20] = _createElementVNode("span", {
    class: "text-white mr-2"
  }, [_createElementVNode("i", {
    class: "pi pi-eye mr-2 lg:hidden"
  }), _createElementVNode("span", {
    class: "font-medium lg:text-xs"
  }, "Client View")], -1)), _createVNode(_component_ToggleSwitch, {
    modelValue: $setup.store.clientView,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $setup.store.clientView = $event),
    class: "header-toggle"
  }, null, 8, ["modelValue"])])])) : _createCommentVNode("", true), $setup.store.currentUser && $setup.store.currentUser.user_type == 'staff' ? (_openBlock(), _createElementBlock("li", _hoisted_29, [_createVNode(_component_HeaderNotifications)])) : _createCommentVNode("", true), _createElementVNode("li", null, [_createVNode(_component_HeaderUser)])])])])) : _createCommentVNode("", true), _createElementVNode("div", {
    class: _normalizeClass({
      'flex flex-column flex-auto': $setup.headerVisible
    })
  }, [_createElementVNode("div", {
    class: _normalizeClass({
      'flex-auto': $setup.headerVisible
    })
  }, [_createVNode(_component_router_view)], 2), $setup.store.hasNewVersion ? (_openBlock(), _createElementBlock("div", _hoisted_30, [_cache[21] || (_cache[21] = _createElementVNode("span", {
    class: "text-sm"
  }, "A new version of Brandripplr is available.", -1)), _createVNode(_component_Button, {
    label: "Refresh",
    size: "small",
    class: "p-button-sm p-button-outlined px-2 py-1",
    onClick: $options.reloadPage
  }, null, 8, ["onClick"])])) : _createCommentVNode("", true)], 2), $setup.headerVisible && $setup.store.currentUser ? (_openBlock(), _createElementBlock("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, [_cache[22] || (_cache[22] = _createElementVNode("img", {
    src: _imports_2,
    alt: "Brandripplr Logo",
    class: "w-7rem"
  }, null, -1)), _createElementVNode("span", _hoisted_33, "© " + _toDisplayString(new Date().getFullYear()) + " Brandripplr.", 1)]), _cache[23] || (_cache[23] = _createElementVNode("span", {
    class: "text-xs flex gap-2"
  }, [_createElementVNode("a", {
    href: "https://www.brandripplr.com/influencer-terms-use",
    target: "_blank",
    class: "text-xs text-500 no-underline hover:text-900 transition-colors transition-duration-150 p-ripple"
  }, "Terms of Use"), _createElementVNode("a", {
    href: "https://www.brandripplr.com/influencer-terms-use#privacypolicy",
    target: "_blank",
    class: "text-xs text-500 no-underline hover:text-900 transition-colors transition-duration-150 p-ripple"
  }, "Privacy Policy"), _createElementVNode("a", {
    href: "https://www.brandripplr.com/influencer-terms-use#refundpolicy",
    target: "_blank",
    class: "text-xs text-500 no-underline hover:text-900 transition-colors transition-duration-150 p-ripple"
  }, "Refund Policy")], -1))])) : _createCommentVNode("", true)]), _createVNode(_component_ClientProtocolsViewDialog), _createVNode(_component_Toast)], 64);
}